import { UIView, YES } from "uicore-ts"
import { CellView } from "../../CellView"

import { RHFont, RHTables } from "./RHDesignTokens"


export class StatisticsPageViewStyling {

    static async waitForLoadingCompletionFrameBudget() {
        UIView.layoutViewsIfNeeded()
        for (let frameIndex = 0; frameIndex < 8; frameIndex++) {
            await new Promise<void>(resolve => requestAnimationFrame(() => resolve()))
        }
    }

    static applyTableCellChrome(cellView: CellView) {

        cellView.configureWithObject({
            style: {
                minWidth: "0",
                overflow: "hidden"
            }
        })

        cellView.titleLabel?.configureWithObject({
            isSingleLine: YES,
            style: {
                display: "block",
                width: "100%",
                minWidth: "0",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: RHTables.rowFontSize,
                lineHeight: RHFont.lineHeightBase
            }
        })

    }

}
